import { useCallback, useRef, useState } from "react";

export function useCitationNavigation() {
  const [selectedCitationNumber, setSelectedCitationNumber] = useState<
    number | null
  >(null);
  const [highlightedId, setHighlightedId] = useState<string | null>(null);
  const timeoutRef = useRef<number | null>(null);

  const selectCitation = useCallback((citationNumber: number) => {
    setSelectedCitationNumber(citationNumber);
    const domId = `citation-thumb-${citationNumber}`;
    const el = document.getElementById(domId);

    el?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    setHighlightedId(domId);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => setHighlightedId(null), 2000);
  }, []);

  return { highlightedId, selectedCitationNumber, selectCitation };
}
